import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IRole } from "../../features/Configurations/RoleManagement/interface";

export function useRole(roleId: string | number) {
  return useQuery<IRole>({
    queryKey: ["role", roleId],
    queryFn: async () => {
      const url = `${API_CONFIG.path.roles}/${roleId}`;
      const response = await httpService.get<IRole>(url);
      return response;
    },
    enabled: !!roleId,
  });
}
